"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _menu = _interopRequireDefault(require("cccisd-icons/menu7"));
var _spinner = _interopRequireDefault(require("cccisd-icons/spinner8"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
var _Filter = _interopRequireWildcard(require("./Filter"));
var _cccisdPaginator = _interopRequireDefault(require("cccisd-paginator"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _utils = require("./utils.js");
var _DoubleScrollbar = _interopRequireDefault(require("./components/DoubleScrollbar"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _once2 = _interopRequireDefault(require("lodash/once"));
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _memoize2 = _interopRequireDefault(require("lodash/memoize"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _cccisdApollo = require("cccisd-apollo");
var _StickyHeader = _interopRequireDefault(require("./StickyHeader.js"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _md = _interopRequireDefault(require("md5"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _Visualization = _interopRequireDefault(require("./Visualization"));
var _store = _interopRequireDefault(require("store"));
var _randomstring = _interopRequireDefault(require("randomstring"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _nanoid = require("nanoid");
var _style = _interopRequireDefault(require("./style.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var getTableColumnsMemoized = (0, _memoize2["default"])(function (columns) {
  return columns.filter(function (column) {
    return !column.hideInTable;
  });
});
var getCsvColumnsMemoized = (0, _memoize2["default"])(function (columns) {
  return columns.filter(function (column) {
    return !column.hideInCsv;
  });
});
var isTopHeaderMemoized = (0, _memoize2["default"])(function (columns) {
  return columns.some(function (column) {
    return column.topHeader;
  });
});
var getQueryMemoized = (0, _memoize2["default"])(function (query) {
  return (0, _isString2["default"])(query) ? (0, _cccisdApollo.gql)(query) : query;
});

/** Table component using graphql-server as a data source */
var GraphqlTable = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(GraphqlTable, _React$Component);
  function GraphqlTable(props) {
    var _this;
    _classCallCheck(this, GraphqlTable);
    _this = _callSuper(this, GraphqlTable, [props]);
    _defineProperty(_assertThisInitialized(_this), "loadTimeout", null);
    _defineProperty(_assertThisInitialized(_this), "loadTimeoutDuration", 500);
    _defineProperty(_assertThisInitialized(_this), "lastLoadingHash", '');
    _defineProperty(_assertThisInitialized(_this), "modals", {});
    _defineProperty(_assertThisInitialized(_this), "storageKey", 'cccisd-graphql-table');
    _defineProperty(_assertThisInitialized(_this), "stateToSave", ['orderBy', 'isAscentOrder', 'filter']);
    _defineProperty(_assertThisInitialized(_this), "tableId", (0, _nanoid.nanoid)());
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var variables = _this.getQueryVariables();
      if (!variables.includes('limit') || !variables.includes('offset')) {
        console.error('The query must include variables "limit" and "offset"');
        return;
      }
      if (typeof _this.props.rowSelectedCallback === 'function') {
        _this.props.rowSelectedCallback(_this.state.selectedRows);
      }
      _this.loadData();
    });
    _defineProperty(_assertThisInitialized(_this), "getStickyColumnWidths", function () {
      var hasStickyColumns = _this.getTableColumns().some(function (column) {
        return column.sticky;
      });
      if (!hasStickyColumns) {
        return;
      }
      var rows = document.getElementById(_this.tableId).querySelectorAll('tbody tr');
      if (rows.length === 0) {
        return;
      }

      // get widths
      {
        var stickyColumns = rows[0].querySelectorAll('td[data-sticky-column]');
        var arr = [];
        var _iterator = _createForOfIteratorHelper(stickyColumns),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var column = _step.value;
            arr.push(column.getBoundingClientRect().width);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (JSON.stringify(arr) !== JSON.stringify(_this.state.stickyColumnWidths)) {
          _this.setState({
            stickyColumnWidths: arr
          });
        }
      }

      // get bg colors
      {
        var _arr = [];
        var _iterator2 = _createForOfIteratorHelper(rows),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var row = _step2.value;
            _arr.push(getComputedStyle(row).getPropertyValue('background-color'));
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        if (JSON.stringify(_arr) !== JSON.stringify(_this.state.rowBgColors)) {
          _this.setState({
            rowBgColors: _arr
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getSettings", function () {
      var settings = {
        orderBy: _this.props.orderBy,
        isAscentOrder: _this.props.isAscentOrder,
        filter: _this.props.filter
      };
      var columns = _this.getTableColumns();
      if (_this.props.saveState) {
        var state = _store["default"].get(_this.storageKey);
        var hash = _this.getHash();
        settings = _objectSpread(_objectSpread({}, settings), (0, _pick2["default"])(state && state[hash] || {}, _this.stateToSave));
      }

      // Check if we have orderBy column
      if (settings.orderBy && !columns.some(function (column) {
        return column.sort && column.name === settings.orderBy;
      })) {
        console.error("There is no sortable column \"".concat(settings.orderBy, "\""));
        settings.orderBy = '';
      }

      // Sort on the first sortable column if there is no orderBy
      if (!settings.orderBy) {
        var firstColumn = columns.find(function (column) {
          return column.sort;
        });
        if (firstColumn) {
          settings.orderBy = firstColumn.name;
        }
      }

      // Remove wrong filters
      var columnNames = columns.map(function (column) {
        return column.name;
      });
      settings.filter = (0, _pick2["default"])(settings.filter, columnNames);
      return settings;
    });
    _defineProperty(_assertThisInitialized(_this), "saveSettings", function () {
      if (!_this.props.saveState) {
        return;
      }
      var hash = _this.getHash();
      var state = _store["default"].get(_this.storageKey);
      var oldSettings = state && state[hash];
      var newSettings = (0, _pick2["default"])(_this.state, _this.stateToSave);
      if (!(0, _isEqual2["default"])(oldSettings, newSettings)) {
        _store["default"].set(_this.storageKey, _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, hash, newSettings)));
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getHash", function () {
      var str = _this.props.name + window.location.hostname + window.location.pathname + _this.getQueryAsString();
      return (0, _md["default"])(str).substr(0, 10);
    });
    _defineProperty(_assertThisInitialized(_this), "setStateAsync", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(state) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (resolve) {
                _this.setState(state, resolve);
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "loadData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _ref3,
        _ref3$useClientCacheO,
        useClientCacheOptions,
        currentClient,
        loadingHash,
        response,
        responseData,
        _args2 = arguments;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _ref3 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, _ref3$useClientCacheO = _ref3.useClientCacheOptions, useClientCacheOptions = _ref3$useClientCacheO === void 0 ? true : _ref3$useClientCacheO;
            currentClient = _this.props.apolloClient || (_this.props.useTaskMaster ? _cccisdApollo.taskMasterClient : _cccisdApollo.client);
            if (!_this.state.loading) {
              _this.setState({
                loading: true
              });
            }
            loadingHash = new Date().getTime();
            _this.lastLoadingHash = loadingHash;
            _context2.next = 7;
            return currentClient.query(_objectSpread(_objectSpread(_objectSpread({}, _this.props.clientOptions), useClientCacheOptions ? _this.props.clientCacheOptions : {}), {}, {
              query: _this.getQuery(),
              variables: _this.getActualVariables(),
              fetchPolicy: 'network-only',
              errorPolicy: 'all'
            }));
          case 7:
            response = _context2.sent;
            if (!(loadingHash !== _this.lastLoadingHash)) {
              _context2.next = 10;
              break;
            }
            return _context2.abrupt("return");
          case 10:
            _context2.prev = 10;
            responseData = (0, _utils.convertResponseData)(response.data);
            _context2.next = 14;
            return _this.setStateAsync(_objectSpread({
              loading: false,
              loadedAtLeastOnce: true
            }, responseData));
          case 14:
            _context2.next = 20;
            break;
          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](10);
            _this.setState({
              loading: false
            });
            console.error(_context2.t0);
          case 20:
            _this.checkColumnsMatchData();
            if (typeof _this.props.dataLoadedCallback === 'function') {
              _this.props.dataLoadedCallback();
            }
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[10, 16]]);
    })));
    _defineProperty(_assertThisInitialized(_this), "scheduleLoadData", function () {
      _this.lastLoadingHash = '';
      if (!_this.state.loading) {
        _this.setState({
          loading: true
        });
      }
      clearTimeout(_this.loadTimeout);
      _this.loadTimeout = setTimeout(_this.loadData, _this.loadTimeoutDuration);
    });
    _defineProperty(_assertThisInitialized(_this), "getQuery", function () {
      return getQueryMemoized(_this.props.query);
    });
    _defineProperty(_assertThisInitialized(_this), "getQueryAsString", function () {
      var string = (0, _get2["default"])(_this.getQuery(), 'loc.source.body');
      if (!string) {
        console.error('Cannot convert query to string');
      }
      return string;
    });
    _defineProperty(_assertThisInitialized(_this), "getQueryVariables", function () {
      return (0, _get2["default"])(_this.getQuery(), 'definitions[0].variableDefinitions').map(function (o) {
        return o.variable.name.value;
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getTableColumns", function () {
      return getTableColumnsMemoized(_this.props.columns);
    });
    _defineProperty(_assertThisInitialized(_this), "getCsvColumns", function () {
      return getCsvColumnsMemoized(_this.props.columns);
    });
    _defineProperty(_assertThisInitialized(_this), "isTopHeader", function () {
      return isTopHeaderMemoized(_this.props.columns);
    });
    _defineProperty(_assertThisInitialized(_this), "getActualVariables", function () {
      // Get ordering
      var orderBy = _this.state.orderBy ? [{
        field: _this.state.orderBy,
        direction: _this.state.isAscentOrder ? 'ASC' : 'DESC'
      }] : null;

      // Get filter
      var filter;
      if (!(0, _isEmpty2["default"])(_this.state.filter) || _this.props.constantFilter) {
        filter = {
          AND: [].concat(_toConsumableArray((0, _map2["default"])(_this.state.filter, function (value, key) {
            var column = _this.props.columns.find(function (item) {
              return item.name === key;
            });
            var type = column.filterSettings && column.filterSettings.type || 'text';
            var field = column.filterSettings && column.filterSettings.field || key;
            var _allFilters$find = _Filter.filters.find(function (item) {
                return item.code === type;
              }),
              getCondition = _allFilters$find.getCondition;
            if (!getCondition) {
              console.error("No getCondition() for filter type \"".concat(type, "\""));
            }
            return getCondition(field, value, column.filterSettings);
          })), _toConsumableArray(_this.props.constantFilter ? [_this.props.constantFilter] : []))
        };
      }
      return _objectSpread(_objectSpread(_objectSpread({}, _this.props.graphqlVariables), {}, {
        limit: _this.state.perPage,
        offset: _this.getStartRowNumber()
      }, orderBy && {
        orderBy: orderBy
      }), filter && {
        filter: filter
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getColumnsLength", function () {
      return _this.getTableColumns().length + (_this.props.showRowNumbers ? 1 : 0);
    });
    _defineProperty(_assertThisInitialized(_this), "getStartRowNumber", function () {
      return (_this.state.currentPage - 1) * _this.state.perPage;
    });
    _defineProperty(_assertThisInitialized(_this), "isOrderAllowed", function () {
      var variables = _this.getQueryVariables();
      var result = variables.includes('orderBy');
      if (!result) {
        _this.showOrderErrorMessage();
      }
      return result;
    });
    _defineProperty(_assertThisInitialized(_this), "downloadCsv", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(event) {
        var universalBOM, _this$props, renders, csvChunkSize, csvHeaderRows, filteredCount, currentClient, serviceUrl, columns, header, base, handle, count, url, variables, query, _loop, link;
        return _regeneratorRuntime().wrap(function _callee3$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              event && event.preventDefault();

              // we need to insert this BOM character at the beginning of the csv file
              // that Excel will recognize it as a UTF-8 encoded file
              universalBOM = "\uFEFF";
              _this$props = _this.props, renders = _this$props.renders, csvChunkSize = _this$props.csvChunkSize, csvHeaderRows = _this$props.csvHeaderRows;
              filteredCount = _this.state.filteredCount;
              currentClient = _this.props.apolloClient || (_this.props.useTaskMaster ? _cccisdApollo.taskMasterClient : _cccisdApollo.client);
              serviceUrl = 'https://compose.service.3cisd.com';
              if (!(filteredCount === 0)) {
                _context4.next = 9;
                break;
              }
              (0, _cccisdNotification["default"])({
                message: 'There is no data to download',
                type: 'danger'
              });
              return _context4.abrupt("return");
            case 9:
              _context4.prev = 9;
              columns = _this.getCsvColumns();
              header = function () {
                if (csvHeaderRows) {
                  return csvHeaderRows.map(function (name) {
                    return columns.map(function (column) {
                      return (0, _utils.prepareCsv)(column[name] || '');
                    }).join(',') + '\n';
                  }).join('');
                }
                return columns.map(function (column) {
                  return (0, _utils.prepareCsv)(column.csvDownloadLabel || column.label);
                }).join(',') + '\n';
              }(); // Generate handle for compose_file microservice
              base = _randomstring["default"].generate({
                length: 10,
                capitalization: 'lowercase'
              });
              handle = base + (0, _md["default"])(base).slice(0, 5);
              count = 0;
              url = '';
              variables = _this.getActualVariables();
              query = _this.getQuery();
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var response, _convertResponseData, data, content, result;
                return _regeneratorRuntime().wrap(function _loop$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _this.setState({
                        loadingCsv: true,
                        loadingCsvPercentage: count / filteredCount * 100
                      });
                      _context3.next = 3;
                      return currentClient.query(_objectSpread(_objectSpread({}, _this.props.clientOptions), {}, {
                        query: query,
                        variables: _objectSpread(_objectSpread({}, variables), {}, {
                          limit: csvChunkSize,
                          offset: count
                        }),
                        fetchPolicy: 'network-only',
                        errorPolicy: 'all'
                      }));
                    case 3:
                      response = _context3.sent;
                      _convertResponseData = (0, _utils.convertResponseData)(response.data), data = _convertResponseData.data;
                      content = data.map(function (row) {
                        return columns.map(function (column) {
                          var value = row[column.name];
                          var renderParams = _objectSpread({
                            value: value,
                            columnName: column.name,
                            row: row,
                            rows: data,
                            loadData: _this.loadData,
                            extraData: _this.state.extraData,
                            columnRenderParams: _this.props.columnRenderParams,
                            isCsv: true
                          }, _this.props.renderParams);
                          if (typeof column.render === 'function') {
                            value = column.render(renderParams);
                          } else if (typeof column.render === 'string') {
                            if (!renders[column.render]) {
                              console.error("There is no render \"".concat(column.render, "\""));
                            } else {
                              value = renders[column.render](renderParams);
                            }
                          }
                          return (0, _utils.prepareCsv)(value);
                        }).join(',');
                      }).join('\n') + '\n';
                      if (count === 0) {
                        content = universalBOM + header + content;
                      }

                      // If we have all the data in one chunk
                      if (!(filteredCount <= csvChunkSize)) {
                        _context3.next = 11;
                        break;
                      }
                      url = 'data:text/csv;charset=utf-8,' + encodeURIComponent(content);
                      _context3.next = 15;
                      break;
                    case 11:
                      _context3.next = 13;
                      return _cccisdAxios["default"].post(serviceUrl, {
                        handle: handle,
                        content: content
                      });
                    case 13:
                      result = _context3.sent;
                      url = "".concat(serviceUrl, "/").concat(result.data.url, "?filename=").concat(_this.props.csvFilename);
                    case 15:
                      count += csvChunkSize;
                    case 16:
                    case "end":
                      return _context3.stop();
                  }
                }, _loop);
              });
            case 19:
              if (!(count < filteredCount)) {
                _context4.next = 23;
                break;
              }
              return _context4.delegateYield(_loop(), "t0", 21);
            case 21:
              _context4.next = 19;
              break;
            case 23:
              // show animation to 100 percent
              _this.setState({
                loadingCsvPercentage: 100
              });
              _context4.next = 26;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 500);
              });
            case 26:
              _this.setState({
                loadingCsv: false
              });
              link = document.createElement('a');
              link.style.display = 'none';
              link.download = _this.props.csvFilename;
              link.href = url;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              _context4.next = 41;
              break;
            case 36:
              _context4.prev = 36;
              _context4.t1 = _context4["catch"](9);
              _this.setState({
                loadingCsv: false
              });
              console.error(_context4.t1);
              (0, _cccisdNotification["default"])({
                message: 'There was an error during downloading CSV',
                type: 'danger'
              });
            case 41:
            case "end":
              return _context4.stop();
          }
        }, _callee3, null, [[9, 36]]);
      }));
      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "visualize", function (e) {
      e && e.preventDefault();
      if (!_this.props.visualize) {
        (0, _cccisdNotification["default"])({
          message: 'There is no data to visualize',
          type: 'warning'
        });
        return;
      }
      _this.visualization.open();
    });
    _defineProperty(_assertThisInitialized(_this), "checkColumnsMatchData", function () {
      if (_this.state.data.length === 0) {
        return;
      }
      var existingColumns = _this.props.columns.filter(function (item) {
        return !item.render;
      }).map(function (item) {
        return item.name;
      });
      var existingData = Object.keys(_this.state.data[0]);
      var diff = (0, _difference2["default"])(existingColumns, existingData);
      if (diff.length > 0) {
        console.error("There is no data for ".concat(diff.map(function (item) {
          return "\"".concat(item, "\"");
        }).join(', '), " columns\nYou have to fix column name or provide some render() function"));
      }
    });
    _defineProperty(_assertThisInitialized(_this), "showOrderErrorMessage", (0, _once2["default"])(function () {
      console.error('Sorting is not allowed\nYou must have variable "orderBy" in the query');
    }));
    _defineProperty(_assertThisInitialized(_this), "isFilterAllowed", function () {
      var variables = _this.getQueryVariables();
      var result = variables.includes('filter');
      if (!result) {
        _this.showFilterErrorMessage();
      }
      return result;
    });
    _defineProperty(_assertThisInitialized(_this), "showFilterErrorMessage", (0, _once2["default"])(function () {
      console.error('Filtering is not allowed\nYou must have variable "filter" in the query');
    }));
    _defineProperty(_assertThisInitialized(_this), "isShowCheckboxes", function () {
      return _this.props.rowActions.length > 0;
    });
    _defineProperty(_assertThisInitialized(_this), "isShowRowActions", function () {
      return _this.props.showRowActions && _this.isShowCheckboxes() && _this.state.selectedRows.length > 0;
    });
    _defineProperty(_assertThisInitialized(_this), "onFilterChange", function (column, value) {
      var filter = _objectSpread({}, _this.state.filter);
      if (value === '') {
        delete filter[column];
      } else {
        filter[column] = value;
      }
      _this.setState({
        filter: filter,
        currentPage: 1
      }, _this.scheduleLoadData);
    });
    _defineProperty(_assertThisInitialized(_this), "removeFilter", function () {
      _this.setState({
        filter: {},
        currentPage: 1
      }, _this.loadData);
    });
    _defineProperty(_assertThisInitialized(_this), "showWrongKeyErrorMessage", (0, _once2["default"])(function () {
      console.error("There is a wrong rowKey=\"".concat(_this.props.rowKey, "\""));
    }));
    _defineProperty(_assertThisInitialized(_this), "onOrder", function (orderBy) {
      var isAscentOrder = _this.state.orderBy !== orderBy ? _this.state.isAscentOrder : !_this.state.isAscentOrder;
      _this.setState({
        orderBy: orderBy,
        isAscentOrder: isAscentOrder,
        currentPage: 1
      }, _this.loadData);
    });
    _defineProperty(_assertThisInitialized(_this), "gotoPage", function (page) {
      _this.setState({
        currentPage: page
      }, _this.loadData);
    });
    _defineProperty(_assertThisInitialized(_this), "onToggleRow", function (value, event) {
      event && event.stopPropagation();
      _this.setState(function (state) {
        return {
          selectedRows: (0, _xor2["default"])(state.selectedRows, [value])
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "openRowActionModal", function (actionName, event) {
      event && event.preventDefault();
      _this.modals[actionName].open();
    });
    _defineProperty(_assertThisInitialized(_this), "runRowAction", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(action, event) {
        return _regeneratorRuntime().wrap(function _callee4$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              event && event.preventDefault();
              _this.setState({
                globalLoading: true
              });
              _context5.next = 4;
              return action({
                selectedRows: _this.state.selectedRows,
                data: _this.state.data,
                loadData: _this.loadData
              });
            case 4:
              _this.deselectAll();
              _this.setState({
                globalLoading: false
              });
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee4);
      }));
      return function (_x3, _x4) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "selectAll", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(event) {
        var result, idList;
        return _regeneratorRuntime().wrap(function _callee5$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              event && event.preventDefault();
              _this.setState({
                loading: true
              });
              _context6.next = 4;
              return _cccisdAxios["default"].post(Boilerplate.route('graphql.idList'), {
                query: _this.getQuery().loc.source.body,
                variables: JSON.stringify(_this.getActualVariables()),
                arrayPath: _this.state.dataPath,
                idPath: _this.props.rowKey
              });
            case 4:
              result = _context6.sent;
              idList = result.data.idList;
              _this.setState({
                selectedRows: idList
              });
              _this.setState({
                loading: false
              });
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee5);
      }));
      return function (_x5) {
        return _ref6.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "deselectAll", function (event) {
      event && event.preventDefault();
      _this.setState({
        selectedRows: []
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderThead", function () {
      var totalStickyLeft = 0;
      var stickyColumnWidths = _toConsumableArray(_this.state.stickyColumnWidths);
      var getColumn = function getColumn(column) {
        var isRowSpan = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var tooltip;
        if (column.tooltip) {
          tooltip = /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].tooltip
          }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                textAlign: 'left'
              }
            }, column.tooltip)
          }, /*#__PURE__*/_react["default"].createElement(_question["default"], null)));
        }
        var columnProps = {};
        if (column.sort && _this.isOrderAllowed()) {
          var className = _style["default"].sortable;
          if (column.name === _this.state.orderBy) {
            className += _this.state.isAscentOrder ? ' ' + _style["default"].sortableAsc : ' ' + _style["default"].sortableDesc;
          }
          columnProps.className = className;
          columnProps.onClick = _this.onOrder.bind(_assertThisInitialized(_this), column.name);
        }
        if (column.headerClassName) {
          columnProps.className = (columnProps.className || '') + ' ' + column.headerClassName;
        }
        if (column.width) {
          columnProps.width = column.width;
        }
        var thStyle;
        var dataAttribute;
        if (column.sticky) {
          dataAttribute = 'data-sticky-column';
          thStyle = {
            position: 'sticky',
            left: totalStickyLeft,
            zIndex: 5,
            backgroundColor: '#fff'
          };
          totalStickyLeft += stickyColumnWidths.shift() || 100;
        }
        return /*#__PURE__*/_react["default"].createElement("th", _extends({
          key: column.name
        }, dataAttribute ? _defineProperty({}, dataAttribute, true) : null, columnProps, isRowSpan ? {
          rowSpan: 2
        } : {}, thStyle ? {
          style: thStyle
        } : null), column.label, tooltip);
      };

      // fix colSpan, depends on the all top headers
      var isTopHeader = _this.isTopHeader();
      var columns = _this.getTableColumns();
      if (isTopHeader) {
        var spanCount = 0;
        var colSpan = 0;
        columns.forEach(function (column, index) {
          if (column.topHeader) {
            if (spanCount > 0) {
              columns[index - colSpan + spanCount].colSpan = colSpan - spanCount;
            }
            colSpan = column.topHeaderSpan || 1;
            column.colSpan = colSpan;
            spanCount = colSpan;
          }
          if (spanCount-- < 1) {
            column.isRowSpan = true;
          }
        });
        if (spanCount > 0) {
          columns[columns.length - colSpan + spanCount].colSpan = colSpan - spanCount;
        }
      }
      var firstRow = [];
      var secondRow = [];
      columns.forEach(function (column) {
        if (column.topHeader) {
          firstRow.push( /*#__PURE__*/_react["default"].createElement("th", {
            key: column.name,
            colSpan: column.colSpan,
            className: _style["default"].topHeader
          }, column.topHeader, column.topHeaderTooltip && /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].tooltip
          }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                textAlign: 'left'
              }
            }, column.topHeaderTooltip)
          }, /*#__PURE__*/_react["default"].createElement(_question["default"], null)))));
        }
        if (column.isRowSpan || !isTopHeader) {
          firstRow.push(getColumn(column, column.isRowSpan));
        } else {
          secondRow.push(getColumn(column));
        }
      });
      if (_this.props.showRowNumbers) {
        firstRow.unshift( /*#__PURE__*/_react["default"].createElement("th", _extends({
          key: "number_column",
          className: _style["default"].numberColumn
        }, secondRow.length > 0 ? {
          rowSpan: 2
        } : {}), "#"));
      }
      if (_this.isShowCheckboxes()) {
        firstRow.unshift( /*#__PURE__*/_react["default"].createElement("th", _extends({
          key: "checkbox_column",
          className: _style["default"].checkboxColumn
        }, secondRow.length > 0 ? {
          rowSpan: 2
        } : {}), "\xA0"));
      }
      var result = [/*#__PURE__*/_react["default"].createElement("tr", {
        key: "first"
      }, firstRow)];
      if (secondRow.length > 0) {
        result.push( /*#__PURE__*/_react["default"].createElement("tr", {
          key: "second"
        }, secondRow));
      }
      return result;
    });
    _defineProperty(_assertThisInitialized(_this), "renderFilter", function () {
      var totalStickyLeft = 0;
      var stickyColumnWidths = _toConsumableArray(_this.state.stickyColumnWidths);
      if (!_this.getTableColumns().some(function (column) {
        return column.filter;
      }) || !_this.isFilterAllowed()) {
        return null;
      }
      var filters = _this.getFilters();
      var columns = _this.getTableColumns().map(function (column) {
        var thStyle;
        var dataAttribute;
        if (column.sticky) {
          dataAttribute = 'data-sticky-column';
          thStyle = {
            position: 'sticky',
            left: totalStickyLeft,
            zIndex: 5,
            backgroundColor: '#fff'
          };
          totalStickyLeft += stickyColumnWidths.shift() || 100;
        }
        thStyle = thStyle ? {
          style: thStyle
        } : null;
        if (!filters[column.name]) {
          return /*#__PURE__*/_react["default"].createElement("th", _extends({
            key: column.name
          }, thStyle, dataAttribute ? _defineProperty({}, dataAttribute, true) : null));
        }
        var columnFilter = _this.props.disableNavigation ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: _this.props.disabledNavigationMessage
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].disabledLayer
        }, filters[column.name])) : filters[column.name];
        return /*#__PURE__*/_react["default"].createElement("th", _extends({
          key: column.name
        }, thStyle, dataAttribute ? _defineProperty({}, dataAttribute, true) : null), columnFilter);
      });
      if (_this.props.showRowNumbers) {
        columns.unshift( /*#__PURE__*/_react["default"].createElement("th", {
          key: "number_column"
        }));
      }
      if (_this.isShowCheckboxes()) {
        columns.unshift( /*#__PURE__*/_react["default"].createElement("th", {
          key: "checkbox_column"
        }));
      }
      return /*#__PURE__*/_react["default"].createElement("tr", null, columns);
    });
    _defineProperty(_assertThisInitialized(_this), "getFilters", function () {
      if (!_this.isFilterAllowed()) {
        return {};
      }
      var filterColumns = _this.getTableColumns().filter(function (column) {
        return column.filter;
      });
      var result = {};
      filterColumns.forEach(function (column) {
        /**
         * Check if QueryEnum table render is specified to derive enum values from extraData.
         * This is needed specifically for Appdefs implementation, and should be revisited.
         * TODO: Handle this better. See https://git.3cisd.com/react-components/base-packages/merge_requests/242
         */
        if ('filterSettings' in column && column.filterSettings.type === 'selectbox' && 'renderAs' in column && column.renderAs.type === 'QueryEnum') {
          var options = column.renderAs.settings.optionsPath.startsWith(_this.state.dataPath) ? _this.state.data : (0, _get2["default"])(_this.state.extraData, column.renderAs.settings.optionsPath, []);
          column.filterSettings.options = (0, _sortBy2["default"])((0, _uniqBy2["default"])(options.map(function (o) {
            return {
              value: (0, _get2["default"])(o, column.renderAs.settings.valuePath) || '',
              label: (0, _get2["default"])(o, column.renderAs.settings.labelPath) || ''
            };
          }), 'value'), 'label');
        }
        result[column.name] = /*#__PURE__*/_react["default"].createElement(_Filter["default"], {
          column: column.name,
          value: _this.state.filter[column.name],
          onFilterChange: _this.onFilterChange,
          settings: column.filterSettings
        });
      });
      return result;
    });
    _defineProperty(_assertThisInitialized(_this), "renderCount", function () {
      return /*#__PURE__*/_react["default"].createElement("div", null, "Showing ", _this.state.filteredCount, " of ", _this.state.totalCount);
    });
    _defineProperty(_assertThisInitialized(_this), "renderTbody", function (customData) {
      if (!_this.state.loadedAtLeastOnce) {
        return null;
      }
      if (_this.state.data.length === 0) {
        return /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
          colSpan: _this.getColumnsLength()
        }, _this.props.noRecordsMessage));
      }
      var _this$props2 = _this.props,
        renders = _this$props2.renders,
        striped = _this$props2.striped;
      var rowClassName = '';
      return _this.state.data.map(function (row, index) {
        var key = row[_this.props.rowKey];
        if (!key) {
          _this.showWrongKeyErrorMessage();
        }
        var selected = _this.state.selectedRows.includes(key);
        if (striped && (striped === true || index === 0 || _this.state.data[index - 1][striped] !== row[striped])) {
          rowClassName = rowClassName === _style["default"].odd ? _style["default"].even : _style["default"].odd;
        }
        var stickyColumnWidths = _toConsumableArray(_this.state.stickyColumnWidths);
        var totalStickyLeft = 0;
        var columns = _this.getTableColumns().filter(function (column) {
          if (column.rowSpanBy && index > 0 && _this.state.data[index - 1][column.rowSpanBy] === row[column.rowSpanBy]) {
            return false;
          }
          return true;
        }).map(function (column) {
          var value = row[column.name];
          if ((0, _isFunction2["default"])(column.render)) {
            value = column.render(_objectSpread(_objectSpread({
              value: value,
              columnName: column.name,
              row: row,
              rows: _this.state.data,
              deselectAll: _this.deselectAll,
              loadData: _this.loadData,
              isRowSelected: selected
            }, _this.props.renderParams), {}, {
              customData: customData,
              extraData: _this.state.extraData,
              columnRenderParams: _this.props.columnRenderParams,
              loading: _this.state.loading
            }));
          } else if ((0, _isString2["default"])(column.render)) {
            if (!renders[column.render]) {
              console.error("There is no render \"".concat(column.render, "\""));
            } else {
              value = renders[column.render](_objectSpread(_objectSpread({
                value: value,
                columnName: column.name,
                row: row,
                rows: _this.state.data,
                loadData: _this.loadData,
                isRowSelected: selected
              }, _this.props.renderParams), {}, {
                customData: customData,
                extraData: _this.state.extraData,
                columnRenderParams: _this.props.columnRenderParams,
                loading: _this.state.loading
              }));
            }
          }
          var rowSpan = 1;
          if (column.rowSpanBy) {
            for (var i = index + 1; i < _this.state.data.length; i++) {
              if (_this.state.data[i][column.rowSpanBy] === row[column.rowSpanBy]) {
                rowSpan++;
              } else {
                break;
              }
            }
          }
          var className = column.className;
          if (typeof column.setClassName === 'function') {
            className += ' ' + column.setClassName(value, row);
          }
          var tdStyle;
          if (typeof column.setStyle === 'function') {
            tdStyle = column.setStyle(value, row);
          }
          var dataAttribute;
          if (column.sticky) {
            dataAttribute = 'data-sticky-column';
            tdStyle = tdStyle || {};
            tdStyle.position = 'sticky';
            tdStyle.left = totalStickyLeft;
            tdStyle.zIndex = 5;
            tdStyle.backgroundColor = _this.state.rowBgColors[index] || '#fff';
            totalStickyLeft += stickyColumnWidths.shift() || 100;
          }
          return /*#__PURE__*/_react["default"].createElement("td", _extends({
            key: column.name,
            className: className
          }, dataAttribute ? _defineProperty({}, dataAttribute, true) : null, rowSpan > 1 ? {
            rowSpan: rowSpan
          } : null, tdStyle ? {
            style: tdStyle
          } : null, _this.props.onRowClick ? {
            onClick: function onClick() {
              return _this.props.onRowClick(row);
            }
          } : null), value);
        });
        if (_this.props.showRowNumbers) {
          columns.unshift( /*#__PURE__*/_react["default"].createElement("td", {
            key: "number_column",
            className: _style["default"].numberColumn
          }, _this.getStartRowNumber() + index + 1));
        }
        if (_this.isShowCheckboxes()) {
          var notSelectable = _this.props.maxSelectableRows && !selected && _this.state.selectedRows.length >= _this.props.maxSelectableRows;
          columns.unshift( /*#__PURE__*/_react["default"].createElement("td", _extends({
            key: "checkbox_column_".concat(selected),
            className: _style["default"].checkbox
          }, notSelectable ? {} : {
            onClick: _this.onToggleRow.bind(_assertThisInitialized(_this), key)
          }), notSelectable ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: "You may only select ".concat(_this.props.maxSelectableRows, " rows.")
          }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("input", {
            type: "checkbox",
            checked: selected,
            readOnly: true,
            disabled: true
          }))) : /*#__PURE__*/_react["default"].createElement("input", {
            type: "checkbox",
            checked: selected,
            readOnly: true
          })));
        }
        var trClassName = (0, _classnames2["default"])(rowClassName, _defineProperty(_defineProperty({}, _style["default"].selected, selected), _style["default"].clickableRow, !selected && _this.props.onRowClick), _this.props.setRowClass && _this.props.setRowClass(row));
        return /*#__PURE__*/_react["default"].createElement("tr", {
          key: row[_this.props.rowKey],
          className: trClassName
        }, columns);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderVisualization", function () {
      if (!_this.props.visualize) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        ref: function ref(elem) {
          _this.visualization = elem;
        },
        trigger: null,
        title: "Visualization",
        size: "900px"
      }, /*#__PURE__*/_react["default"].createElement(_Visualization["default"], _extends({
        apolloClient: _this.props.apolloClient || (_this.props.useTaskMaster ? _cccisdApollo.taskMasterClient : _cccisdApollo.client),
        tableVariables: _this.getActualVariables()
      }, _this.props.visualize)));
    });
    _defineProperty(_assertThisInitialized(_this), "hasIdListRoute", function () {
      return Boilerplate && Boilerplate.route && Boilerplate.route('graphql.idList') && /^http/.test(Boilerplate.route('graphql.idList'));
    });
    _defineProperty(_assertThisInitialized(_this), "renderTableActions", function () {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-sm btn-default dropdown-toggle ".concat(_style["default"].multipurposeButton, " ").concat(_this.state.loading ? _style["default"].rotating : ''),
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      }, _this.state.loading ? /*#__PURE__*/_react["default"].createElement(_spinner["default"], null) : /*#__PURE__*/_react["default"].createElement(_menu["default"], null)), /*#__PURE__*/_react["default"].createElement("ul", {
        className: "dropdown-menu"
      }, /*#__PURE__*/_react["default"].createElement("li", {
        key: "reloadData"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "",
        onClick: function onClick(e) {
          e.preventDefault();
          _this.loadData({
            useClientCacheOptions: false
          });
        }
      }, "Reload data")), _this.isShowCheckboxes() && _this.hasIdListRoute() && /*#__PURE__*/_react["default"].createElement("li", {
        key: "selectAll"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "",
        onClick: _this.selectAll
      }, "Select all")), _this.isShowCheckboxes() && /*#__PURE__*/_react["default"].createElement("li", {
        key: "deselectAll"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "",
        onClick: _this.deselectAll
      }, "Deselect all")), /*#__PURE__*/_react["default"].createElement("li", {
        key: "downloadCsv"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "",
        onClick: _this.downloadCsv
      }, "Download CSV")), _this.props.visualize && /*#__PURE__*/_react["default"].createElement("li", {
        key: "visualize"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "",
        onClick: _this.visualize
      }, "Visualize"))));
    });
    _defineProperty(_assertThisInitialized(_this), "renderRowActions", function () {
      var rowActions = _this.props.rowActions;
      if (!_this.isShowRowActions()) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-sm btn-default dropdown-toggle",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      }, _this.state.selectedRows.length, " selected ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "caret"
      })), /*#__PURE__*/_react["default"].createElement("ul", {
        className: "dropdown-menu"
      }, rowActions.map(function (action) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: action.name
        }, action.inModal ? /*#__PURE__*/_react["default"].createElement("a", {
          href: "",
          onClick: _this.openRowActionModal.bind(_assertThisInitialized(_this), action.name)
        }, action.title) : /*#__PURE__*/_react["default"].createElement("a", {
          href: "",
          onClick: _this.runRowAction.bind(_assertThisInitialized(_this), action.action)
        }, action.title));
      }))), rowActions.filter(function (action) {
        return action.inModal;
      }).map(function (action) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
          key: action.name,
          trigger: null,
          title: action.title,
          ref: function ref(element) {
            _this.modals[action.name] = element;
          },
          size: action.size
        }, /*#__PURE__*/_react["default"].createElement(action.component, {
          selectedRows: _this.state.selectedRows,
          loadData: _this.loadData,
          deselectAll: _this.deselectAll
        }));
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderRemoveFilterButton", function () {
      var removeFilterButton = _this.getRemoveFilterButton();
      return removeFilterButton ? /*#__PURE__*/_react["default"].createElement("div", null, removeFilterButton) : null;
    });
    _defineProperty(_assertThisInitialized(_this), "getRemoveFilterButton", function () {
      if ((0, _isEmpty2["default"])(_this.state.filter)) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary btn-xs",
        onClick: _this.removeFilter
      }, /*#__PURE__*/_react["default"].createElement(_cross["default"], {
        spaceRight: true
      }), "Remove Filter");
    });
    _defineProperty(_assertThisInitialized(_this), "renderPaginator", function () {
      var place = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'top';
      var className = place === 'top' ? _style["default"].topPaginator : _style["default"].bottomPaginator;
      var paginator = _this.getPaginator();
      return paginator ? /*#__PURE__*/_react["default"].createElement("div", {
        className: className
      }, paginator) : null;
    });
    _defineProperty(_assertThisInitialized(_this), "getPaginator", function () {
      var total = Math.ceil(_this.state.filteredCount / _this.state.perPage);
      if (total <= 1) {
        return null;
      }
      var paginator = /*#__PURE__*/_react["default"].createElement(_cccisdPaginator["default"], {
        total: total,
        currentPage: _this.state.currentPage,
        onPageChange: _this.gotoPage
      });
      if (_this.props.disableNavigation) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: _this.props.disabledNavigationMessage
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].disabledLayer
        }, paginator));
      }
      return paginator;
    });
    _defineProperty(_assertThisInitialized(_this), "renderTfoot", function (customData) {
      if (!_this.props.showTotal) {
        return null;
      }
      var renders = _this.props.renders;
      var columns = _this.getTableColumns();
      columns = columns.map(function (column) {
        if (!column.totalPath) {
          return /*#__PURE__*/_react["default"].createElement("th", {
            key: column.name
          });
        }
        var value = (0, _get2["default"])(_this.state.extraData, column.totalPath, '');
        var renderSettings = _objectSpread(_objectSpread({
          value: value,
          columnName: column.name,
          row: {},
          rows: _this.state.data,
          loadData: _this.loadData
        }, _this.props.renderParams), {}, {
          customData: customData,
          loading: _this.state.loading,
          extraData: _this.state.extraData,
          columnRenderParams: _this.props.columnRenderParams,
          inTotal: true
        });
        if ((0, _isFunction2["default"])(column.render)) {
          value = column.render(renderSettings);
        } else if ((0, _isString2["default"])(column.render)) {
          if (!renders[column.render]) {
            console.error("There is no render \"".concat(column.render, "\""));
          } else {
            value = renders[column.render](renderSettings);
          }
        }
        var className = column.className;
        if (typeof column.setClassName === 'function') {
          className += ' ' + column.setClassName(value, {});
        }
        var tdStyle;
        if (typeof column.setStyle === 'function') {
          tdStyle = column.setStyle(value, {});
        }
        return /*#__PURE__*/_react["default"].createElement("th", _extends({
          key: column.name,
          className: className
        }, tdStyle ? {
          style: tdStyle
        } : null), value);
      });
      if (_this.props.showRowNumbers) {
        columns.unshift( /*#__PURE__*/_react["default"].createElement("th", {
          key: "number_column"
        }));
      }
      if (_this.isShowCheckboxes()) {
        columns.unshift( /*#__PURE__*/_react["default"].createElement("th", {
          key: "checkbox_column"
        }));
      }
      return /*#__PURE__*/_react["default"].createElement("tfoot", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", null, _this.props.totalHeader), columns.slice(1)));
    });
    _defineProperty(_assertThisInitialized(_this), "renderTable", function (customData) {
      var table = /*#__PURE__*/_react["default"].createElement("table", {
        className: (0, _classnames2["default"])(_this.props.className, _this.props.additionalClassName, _style["default"].table),
        id: _this.tableId
      }, /*#__PURE__*/_react["default"].createElement("thead", null, _this.renderThead(), _this.renderFilter()), /*#__PURE__*/_react["default"].createElement("tbody", null, _this.renderTbody(customData)), _this.renderTfoot(customData));
      if (_this.props.isStickyHeader) {
        return /*#__PURE__*/_react["default"].createElement(_StickyHeader["default"], {
          header: /*#__PURE__*/_react["default"].createElement("table", {
            className: (0, _classnames2["default"])(_this.props.className, _this.props.additionalClassName, _style["default"].table)
          }, /*#__PURE__*/_react["default"].createElement("thead", null, _this.renderThead(), _this.renderFilter())),
          table: table
        });
      }
      return table;
    });
    _this.state = _objectSpread({
      globalLoading: false,
      loading: true,
      loadedAtLeastOnce: false,
      loadingCsv: false,
      loadingCsvPercentage: 0,
      data: [],
      dataPath: '',
      extraData: {},
      totalCount: 0,
      filteredCount: 0,
      currentPage: 1,
      perPage: props.perPage,
      selectedRows: (0, _cloneDeep2["default"])(props.selectedRows),
      stickyColumnWidths: [],
      rowBgColors: []
    }, _this.getSettings());
    return _this;
  }
  _createClass(GraphqlTable, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this.getStickyColumnWidths();
      this.saveSettings();
      if (this.props.query !== prevProps.query || !(0, _isEqual2["default"])(this.props.graphqlVariables, prevProps.graphqlVariables)) {
        this.loadData();
      }
      if (this.state.selectedRows.length > 0 && (!(0, _isEqual2["default"])(this.props.graphqlVariables, prevProps.graphqlVariables) || !(0, _isEqual2["default"])(this.props.constantFilter, prevProps.constantFilter) || !(0, _isEqual2["default"])(this.state.filter, prevState.filter) && !this.props.keepSelectedOnFiltering)) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          selectedRows: []
        });
      }
      if (typeof this.props.rowSelectedCallback === 'function') {
        this.props.rowSelectedCallback(this.state.selectedRows);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        render = _this$props3.render,
        showDoubleScrollbar = _this$props3.showDoubleScrollbar;
      var renderDefault = function renderDefault(customData) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, _this2.renderVisualization(), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].topBar
        }, _this2.renderTableActions(), _this2.renderRowActions(), _this2.renderCount(), _this2.renderRemoveFilterButton(), _this2.renderPaginator('top')), showDoubleScrollbar ? /*#__PURE__*/_react["default"].createElement(_DoubleScrollbar["default"], null, _this2.renderTable(customData)) : /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].tableScroll,
          "data-table-scroll-wrapper": true
        }, _this2.renderTable(customData)), _this2.renderPaginator('bottom'));
      };
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.state.loadingCsv,
        percentage: this.state.loadingCsvPercentage,
        showImmediately: true
      }), /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.state.globalLoading
      }, render ? render({
        paginator: this.getPaginator(),
        count: this.renderCount(),
        removeFilterButton: this.getRemoveFilterButton(),
        data: this.state.data,
        loading: this.state.loading,
        downloadCsv: this.downloadCsv,
        filters: this.getFilters(),
        selectedRows: this.state.selectedRows,
        loadData: this.loadData,
        visualize: this.visualize,
        renderDefault: renderDefault
      }) : renderDefault()));
    }
  }]);
  return GraphqlTable;
}(_react["default"].Component);
_defineProperty(GraphqlTable, "propTypes", {
  /** The name for the table. It's used when saving the table state. If there is only one table on the page it's not necessary to assign a name. */
  name: _propTypes["default"].string,
  /** Graphql query */
  query: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
  /** List of columns */
  columns: _propTypes["default"].array,
  /** A key with a unique value. This key must exist. */
  rowKey: _propTypes["default"].string,
  /** Table class */
  className: _propTypes["default"].string,
  /** Additional table class which is added to default ones */
  additionalClassName: _propTypes["default"].string,
  /** Column name that is used for default sorting */
  orderBy: _propTypes["default"].string,
  /** Use ascending order or not by default? */
  isAscentOrder: _propTypes["default"].bool,
  /** The default filter <i>e.g.</i> {name: "Bob", email: "some@gmail.com"} */
  filter: _propTypes["default"].object,
  /** A filter that will be applied to the table permanently. <i>e.g.</i>:
  <pre>{
  AND: [
  { contains: { field: "user.email", string: "gmail.com" }},
  { contains: { field: "user.firstName", string: "Bob" }},
  ]
  }</pre>
  */
  constantFilter: _propTypes["default"].object,
  /** Show row numbers or not? */
  showRowNumbers: _propTypes["default"].bool,
  /** Show total row or not? */
  showTotal: _propTypes["default"].bool,
  /** Header for the total row */
  totalHeader: _propTypes["default"].node,
  /** Message to show when there are no records */
  noRecordsMessage: _propTypes["default"].string,
  /** List of custom renders for columns */
  renders: _propTypes["default"].object,
  /** Default number of rows per one page */
  perPage: _propTypes["default"].number,
  /** List of possible row actions */
  rowActions: _propTypes["default"].array,
  /** Save the table's state (sort and filter params) in local storage? */
  saveState: _propTypes["default"].bool,
  /** Variables which need to be passed to grapqhl query */
  graphqlVariables: _propTypes["default"].object,
  /** @ignore Additional params passed to renders */
  renderParams: _propTypes["default"].object,
  /** @ignore Override apollo client */
  apolloClient: _propTypes["default"].object,
  /** Additional options to pass to cccisd-apollo. */
  clientOptions: _propTypes["default"].object,
  /** This options will override clientOptions. They won't be used only during RELOADING the data. */
  clientCacheOptions: _propTypes["default"].object,
  /** CSV filename */
  csvFilename: _propTypes["default"].string,
  /** Number of rows to proceed by the backend when generating CSV */
  csvChunkSize: _propTypes["default"].number,
  /** List of column props which will be used to compose csv header. It will allow to create multirow header with additional information. */
  csvHeaderRows: _propTypes["default"].array,
  /** Show striped rows or not? If it's a string it means column name. In this case rows will be striped when the column name value is changed. */
  striped: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  /** Show row actions dropdown or not */
  showRowActions: _propTypes["default"].bool,
  /** Disable navigation (moving to pages, filtering, sorting) or not? */
  disableNavigation: _propTypes["default"].bool,
  /** Message to show when navigation is disabled */
  disabledNavigationMessage: _propTypes["default"].string,
  /** A click event handler for a whole row that accepts row objects */
  onRowClick: _propTypes["default"].func,
  /** If this is a function then it will set a className for every row when called. The row can be passed into the function.  */
  setRowClass: _propTypes["default"].func,
  /** Custom render to show table in a different shape */
  render: _propTypes["default"].func,
  /** Some params which will be passed to every column render */
  columnRenderParams: _propTypes["default"].object,
  /** Use Task Master to run a complicated query */
  useTaskMaster: _propTypes["default"].bool,
  /** An array of rows that will be selected by default */
  selectedRows: _propTypes["default"].array,
  /** A function that will be called after changing selected rows */
  rowSelectedCallback: _propTypes["default"].func,
  /** When filtering keep currently selected rows */
  keepSelectedOnFiltering: _propTypes["default"].bool,
  /** A function that will be called after any data is returned from the query */
  dataLoadedCallback: _propTypes["default"].func,
  /** Set a limit on the number of rows that can be selected for row actions */
  maxSelectableRows: _propTypes["default"].number,
  /** Show a second scrollbar at the top of the table */
  showDoubleScrollbar: _propTypes["default"].bool,
  /** Stick the header to the top of the page or not */
  isStickyHeader: _propTypes["default"].bool
});
_defineProperty(GraphqlTable, "defaultProps", {
  name: '',
  columns: [],
  rowKey: 'id',
  className: 'table table-condensed table-bordered',
  additionalClassName: '',
  orderBy: '',
  isAscentOrder: true,
  filter: {},
  constantFilter: null,
  showRowNumbers: false,
  showTotal: false,
  totalHeader: 'Total:',
  noRecordsMessage: 'No matching records found',
  renders: {},
  perPage: 50,
  rowActions: [],
  saveState: false,
  graphqlVariables: {},
  renderParams: {},
  csvFilename: 'download.csv',
  csvChunkSize: 500,
  striped: true,
  showRowActions: true,
  disabledNavigationMessage: 'Navigation is disabled',
  columnRenderParams: {},
  useTaskMaster: false,
  selectedRows: [],
  clientOptions: {},
  clientCacheOptions: {},
  showDoubleScrollbar: false,
  keepSelectedOnFiltering: false
});